import TreatmentGroupPicker from './TreatmentGroupPicker';

export default TreatmentGroupPicker;
